/**
 * BrandDetailContainer
 * --
 */
import React from 'react';
import BrandDetailPresenter from './BrandDetailPresenter';

const BrandDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <BrandDetailPresenter />
    </>
  );
};

export default BrandDetailContainer;
